export const countryStore = {
    state: () => ({
        countries: []
    }),
    mutations: {
        setCountries(state, countries) {
            state.countries = Array.isArray(countries) ? countries : [];
        }
    }
}
